import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

export default new Vuex.Store({
  plugins: [
    createPersistedState({
      key: "my_app_store", 
      paths: ["globalSkill"]
    })
  ],

  state: {
    globalSkill: null
  },

  getters: {
    getGlobalSkill(state) {
      return state.globalSkill;
    }
  },

  mutations: {
    setGlobalSkill(state, skill) {
      state.globalSkill = skill;
    }
  },

  actions: {
    updateGlobalSkill({ commit }, skill) {
      commit("setGlobalSkill", skill);
    }
  }
});
